import React from "react";

const Services = ({ classicHeader, darkTheme }) => {
  // services details
  const services = [
    {
      name: "Software Engineering Skills",
      desc: "Skilled in Python, Scala, Clojure, JavaScript, and TypeScript, with a strong focus on backend systems",
      icon: "fas fa-code",
    },
    {
      name: "System Architecture",
      desc: "Focus on strong, scalable designs. Always plan before coding.",
      icon: "fas fa-sitemap",
    },
    {
      name: "Advanced Cloud Solutions",
      desc: "Proficient with AWS and Azure, focusing on efficient cloud architectures and a particular interest in serverless frameworks.",
      icon: "fas fa-cloud",
    },
    {
      name: "E-Commerce Expertise",
      desc: "Developed platforms for B2B and B2C, ensuring smooth and functional user experiences.",
      icon: "fas fa-shopping-cart",
    },
    {
      name: "Multi-Tenant Systems",
      desc: "Built platforms serving multiple clients from a single setup.",
      icon: "fas fa-user-friends",
    },
    {
      name: "IoT Projects",
      desc: "Supported device integrations for connected solutions.",
      icon: "fas fa-broadcast-tower",
    },
  ];

  return (
    <section
      id="services"
      className={"section " + (darkTheme ? "bg-dark-2" : "bg-light")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-white-50  opacity-1" : "text-light  opacity-4")
            }
          >
            Services
          </h2>
          <p
            className={
              "text-9  fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            What I Do?
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}
        {/* content start */}
        <div className="row">
          <div className="col-lg-11 mx-auto">
            <div className="row">
              {services.length > 0 &&
                services.map((service, index) => (
                  <div className="col-md-6" key={index}>
                    <div className="featured-box style-3 mb-5">
                      <div
                        className={
                          "featured-box-icon text-primary  shadow-sm rounded " +
                          (darkTheme ? "bg-dark-1" : "bg-white")
                        }
                      >
                        <i className={service.icon} />
                      </div>
                      <h3 className={darkTheme ? "text-white" : ""}>
                        {service.name}
                      </h3>
                      <p
                        className={"mb-0 " + (darkTheme ? "text-white-50" : "")}
                      >
                        {service.desc}
                      </p>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
        {/* content end */}
      </div>
    </section>
  );
};

export default Services;
